import { Component, Input, OnInit } from '@angular/core';
import { IROPS_STATUS } from '@app/enums/irops.enum';
import { FlightSummary, Segment } from '@app/models/micro';
import { boardingTime } from '@app/utils';
import {
  checkSegmentIsAffected,
  getFlightsNewInfoEstimatedDeparture,
  getSegmentArrivalDate,
  getSegmentDepartureDate,
  parseTime,
} from '@app/utils/functions/srIrops';

@Component({
    selector: 'flight-data-info',
    templateUrl: './flight-data-info.component.html',
    styleUrls: ['./flight-data-info.component.scss'],
    standalone: false
})
export class FlightDataInfoComponent implements OnInit {

  @Input() flightSummary: FlightSummary;

  typeIrops: IROPS_STATUS;
  isDomestic: boolean;
  statusIrops: any;
  gate: string;
  firstSegment: any;
  lastSegment: any;

  constructor() { }

  ngOnInit() {
    const statusAllow = [IROPS_STATUS.DELAYED, IROPS_STATUS.EARLY, IROPS_STATUS.CANCELLED];
    const { segments } = this.flightSummary;
    this.isDomestic = this.flightSummary?.isDomestic;
    this.gate = this.flightSummary?.boardingGate || '';

    this.firstSegment = segments[0];

    if (this.firstSegment?.flightsNewInfo && statusAllow.includes(this.firstSegment?.flightsNewInfo?.status as IROPS_STATUS)) {
      const status = this.firstSegment?.flightsNewInfo?.status;

      this.statusIrops = status;
    }

    this.lastSegment = segments[segments?.length - 1];
  }

  get validStatusIrops() {
    const validStatus = (this.firstSegment?.flightsNewInfo?.status == IROPS_STATUS.DELAYED || this.firstSegment?.flightsNewInfo?.status == IROPS_STATUS.EARLY);
    return checkSegmentIsAffected(this.firstSegment) && validStatus;
  }

  get flightNumber() {
    let operatingCarrier;
    let operatingCode;

    operatingCarrier = this.firstSegment?.operatingCarrier;
    operatingCode = parseInt(this.firstSegment?.operatingFlightCode);

    return `${operatingCarrier} ${operatingCode}`;
  }

  get departureTime() {
    return getSegmentDepartureDate(this.firstSegment);
  }

  get arrivalTime() {
    return getSegmentArrivalDate(this.lastSegment);
  }

  get boardingTime() {
    return boardingTime(
            checkSegmentIsAffected(this.firstSegment) && this.validStatusIrops
              ? getFlightsNewInfoEstimatedDeparture(this.firstSegment)
              : this.firstSegment?.departureDateTime,
            this.isDomestic
          ).toDate();
  }

}
